"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightFlexDays = exports.highlightCurrentDate = exports.getMinDate = exports.getMaxDate = void 0;

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

var _subDays = _interopRequireDefault(require("date-fns/subDays"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _SearcherDatepicker = require("./SearcherDatepicker.model");

var getMinDate = (0, _memoize2["default"])(function (date) {
  return (0, _addDays["default"])(date, 1);
});
exports.getMinDate = getMinDate;
var getMaxDate = (0, _memoize2["default"])(function (date) {
  return (0, _addMonths["default"])(date, _SearcherDatepicker.MAX_MONTHS);
});
exports.getMaxDate = getMaxDate;

var highlightFlexDays = function highlightFlexDays(date) {
  var hDate = [{
    'react-datepicker__day--highlighted': [(0, _subDays["default"])(date, -2), (0, _subDays["default"])(date, -1), (0, _subDays["default"])(date, 1), (0, _subDays["default"])(date, 2)]
  }, {
    'react-datepicker__day--selected': [new Date(date)]
  }];
  return hDate;
};

exports.highlightFlexDays = highlightFlexDays;

var highlightCurrentDate = function highlightCurrentDate(date) {
  var hDate = [{
    'react-datepicker__day--selected': [new Date(date)]
  }];
  return hDate;
};

exports.highlightCurrentDate = highlightCurrentDate;